angular.module('qkr', ['ngRoute', 'route-segment', 'ngCookies', 'view-segment', 'angularFileUpload', 'ui.bootstrap',
    'ui.sortable', 'ui.bootstrapextras', 'angularCharts', 'colorpicker.module', 'gettext', 'angularSpinner',
    'com.2fdevs.videogular', 'com.2fdevs.videogular.plugins.poster', 'com.2fdevs.videogular.plugins.overlayplay',
    'com.2fdevs.videogular.plugins.controls', 'com.2fdevs.videogular.plugins.buffering', 'ui.select2',
    'ui.slider', 'dibari.angular-ellipsis', 'google-maps'.ns(), 'qkr.configuration',
    'lodash', 'qkr.inventory', 'qkr.tax', 'qkr.coupon', 'qkr.seatingMap', 'qkr.mssConfig', 'qkr.refund',
    'qkr.finance1','qkr.partner.reports',
    'ngFileUpload', 'qkr.department', 'qkr.payment.gateway', 'qkr.default.products', 'monospaced.qrcode',
    'ngMessages', 'qkr.session.expiry', 'lodash', 'ngAnimate', 'qkr.integration.settings', 'qkr.merchant.reports',
    'qkr.fraud.check']);

angular.module('qkr.inventory', ['ngRoute', 'route-segment', 'qkr.configuration']);
angular.module('qkr.coupon', ['ngRoute', 'route-segment', 'view-segment', 'gettext']);
angular.module('qkr.default.products', []);
angular.module('qkr.department', []);
angular.module('qkr.mssConfig', []);
angular.module('lodash', []);
angular.module('qkr.refund', ['ngRoute', 'route-segment', 'view-segment', 'gettext']);
angular.module('qkr.inventory', ['ngRoute', 'route-segment', 'qkr.configuration']);
angular.module('qkr.payment.gateway', []);
angular.module('qkr.seatingMap', []);
angular.module('qkr.session.expiry', []);
angular.module('qkr.tax', ['ngRoute', 'route-segment', 'view-segment', 'gettext']);
angular.module('qkr.integration.settings', []);
angular.module('qkr.finance1', ['ngRoute', 'route-segment', 'qkr.configuration']);
angular.module('qkr.partner.reports', []);
angular.module('qkr.merchant.reports', []);
angular.module('qkr.fraud.check', []);




// WEBPACK FOOTER //
// ./src/_module.declarations.js